import { makeStyles } from '@mui/styles'
import { NEON_BLUE_LIGHT } from '@returnmates/client-core/src/constants/colors'

interface Props {
  fullWidth?: boolean
}

const useStyles = makeStyles(() => ({
  select: {
    border: '2px solid transparent',
    borderRadius: 5,
    width: ({ fullWidth }: Props) => (fullWidth ? '100%' : 256),
    '&:hover': {
      border: `2px solid ${NEON_BLUE_LIGHT}`,
    },
    '&.Mui-focused': {
      border: `2px solid ${NEON_BLUE_LIGHT}`,
    },
  },
}))

export default useStyles
